module.exports = __webpack_public_path__ + "static/media/burgerQueen.797e7a5d.png";